import { initialState, TCategoryMethods, TCategoryStore } from "./category.state";
import { categoryReducer } from "./category.reducer";

// ✅ Reusable store methods
export const createCategoryActions = (
    set: any,
    get: () => TCategoryStore
): Pick<TCategoryStore, TCategoryMethods> => ({
    dispatch: (action) => set((state: TCategoryStore) => categoryReducer(state, action)),

    getCategoriesByProperty: (property, value) => {
        return get().categories.filter((item) => item[property] === value);
    },

    getCategoryByProperty: (property, value) => {
        return get().categories.find((item) => item[property] === value);
    },

    getSelectedDisclosureIds: () => {
        return get().categories
            .filter(item => item.selectedTopicIds.length > 0)
            .reduce((list: number[], item) => {
                return item.selectedTopicIds.length > 0 && !list.includes(item.disclosureId)
                    ? [...list, item.disclosureId]
                    : list
            }, []);
    },

    getSelectedCategories: () => {
        return get().categories
            .filter(item => item.selectedTopicIds.length > 0);
    },

    reset: () => {
        set(initialState);
    },
});
